'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = {
  pad: function pad(value, width) {
    if (value == null) {
      throw new Error('value is required');
    }

    width = width || 2;

    var padded = new Array(width).join('0') + value;

    return padded.substring(padded.length - width);
  },

  getKey: function getKey(value) {
    if (typeof value !== 'string') {
      throw new Error('value is required string');
    }

    // Replace all non-alphanumerics with hyphens, then replace all instances of
    // multiple hyphens with a single hyphen, then trim hyphens from beginning
    // and end.

    return value.toLowerCase().replace(/[^0-9a-z]/g, '-').replace(/-{2,}/g, '-').replace(/^-?(.+?)-?$/, '$1');
  },

  normalizeUnicodeNull: function normalizeUnicodeNull(value) {
    var _this = this;

    if (value === '\0') {
      return null;
    } else if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
      return value;
    }

    return Object.keys(value).reduce(function (copy, key) {
      copy[key] = _this.normalizeUnicodeNull(value[key]);

      return copy;
    }, {});
  }
};